import { LightShowSegment } from './lightshow-segment';
import { LightShowOperation } from '../Operations/lightshow-operation';
import { SetColorOperation } from '../Operations/set-color-operation';
import { StrobeOperation } from '../Operations/strobe-operation';
import { TorchOperation } from '../Operations/torch-operation';
import { FlashTypes } from '../operation-types';

export class ToggleSmartColorsSegment extends LightShowSegment {
  static fadeInDuration = 200;
  public colors: string[];

  public init() {
    this.color = 'blue';
    this.minDuration = ToggleSmartColorsSegment.fadeInDuration;
    this.enableSegmentGrips = true;
  }

  public addOperations(operations: LightShowOperation[]) {
    let colorIdx = -1;
    const coveredFlashLightOperations = operations
      .filter(op => op instanceof StrobeOperation || op instanceof TorchOperation)
      .filter(op => op.position >= this.position && op.position < this.position + this.duration)
      .sort((o1, o2) => o1.position - o2.position);

    coveredFlashLightOperations.forEach((op, index) => {
      const nextFlashOperation = coveredFlashLightOperations[index + 1];
      const v2ColorDuration = nextFlashOperation ? nextFlashOperation.position - op.position : Math.abs(this.duration + this.position - op.position);
      operations.push(new SetColorOperation(op.position, 0, this.colors[(colorIdx = (colorIdx + 1) % this.colors.length)], v2ColorDuration, 0));
    });

    operations.push(new SetColorOperation(this.position + this.duration + 101, 0, '#000000', 0, 0));

  }
}
